import { render, staticRenderFns } from "./profileDropdown.vue?vue&type=template&id=fb851ed8&scoped=true"
import script from "./profileDropdown.vue?vue&type=script&lang=js"
export * from "./profileDropdown.vue?vue&type=script&lang=js"
import style0 from "./profileDropdown.vue?vue&type=style&index=0&id=fb851ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb851ed8",
  null
  
)

export default component.exports